import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Starts each navigation at the top of the page — unless the URL names a
 * fragment, in which case that wins.
 *
 * The fragment case matters for the marketing nav, whose section links are
 * "/#features" and friends. Reached from any route other than "/", those are
 * full document loads, and the target element does not exist when the browser
 * first tries to scroll to it: React has not rendered yet. The browser gives
 * up, then this effect runs and scrolls to the top, so the link silently lands
 * on the hero instead of the section. By the time the effect runs the element
 * does exist, so resolving it here is what makes those links work at all.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (target) {
        target.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
